













































import {Component, Prop, Provide, Vue} from 'vue-property-decorator'
import {Helper} from 'simpli-web-sdk'
import moment from 'moment'
import {PanelUser} from '@/model/resource/PanelUser'
import {InputPanelUserSchema} from '@/schema/resource/PanelUser/InputPanelUserSchema'

@Component
export default class ModalUpdateExpiringDateIntenational extends Vue {
  model = new PanelUser()
  schema = new InputPanelUserSchema()

  openEvent(id?: number) {
    this.$emit('open')

    if (id) {
      this.model.getPanelUser(id)
    } else {
      this.close()
    }
  }

  closeEvent() {
    this.model.reset()
    this.$emit('close')
  }

  validate(date: string | null) {
    const d = moment(date ?? '')
    return moment(d).isValid()
  }

  async confirmEvent() {
    if (this.model.dueDate == null) {
      Helper.abort('system.error.emptyDataVencimento')
    }

    if (!this.validate(this.model.dueDate)) {
      Helper.abort('system.error.invalidDataVencimento')
    }

    await this.model.updateDueDate(this.model.dueDate ?? '')
    await Helper.success('system.success.persist')
    this.close()
  }

  async cancelEvent() {
    this.$emit('cancel')
    this.close()
  }

  close() {
    this.$modal.close('updateExpiringDateInternational')
    this.$tip.hideAll()
  }
}
